import React,{Component} from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col
} from 'reactstrap';

import find from 'lodash/find';

import ProgressBarSVG from '../../../shared/components/ProgressBarSVG';

class RatableResults extends Component {
  render(){
    const { engagement, engagementKPIs } = this.props,
      upKPI = find(engagementKPIs.answerKPIs, (a) => a.answer === '1') || {answersNum:0},
      downKPI = find(engagementKPIs.answerKPIs, (a) => a.answer === '0') || {answersNum:0},
      upPercent = Math.round((upKPI.answersNum / (upKPI.answersNum + downKPI.answersNum)) * 100),
      downPercent = 100 - upPercent;

      return (
        <div className='EngagementResults'>
          <Row style={{pageBreakInside:'avoid'}}>
            <Col xs='4'>
              <br />
              <br />
              <h6>Video</h6>
              <video
                autoPlay
                loop
                muted
                style={{maxWidth:200,borderRadius:10}}
              >
                <source src={engagement.videoURL} />
                Sorry, your browser does not support this type of video.
              </video>
            </Col>
            <Col xs='8'>
              <br />
              <br />
              <br />
              {engagement.text || 'What did you think of this video?'}
              <br />
              <br />
              <ProgressBarSVG
                title={'I Liked it'}
                votes={upKPI.answersNum}
                totalVotes={downKPI.answersNum + upKPI.answersNum}
                displayPercent={upPercent}
                winner={upKPI.answersNum > downKPI.answersNum}
              />
              <ProgressBarSVG
                title={'Not for me'}
                votes={downKPI.answersNum}
                totalVotes={downKPI.answersNum + upKPI.answersNum}
                displayPercent={downPercent}
                winner={downKPI.answersNum > upKPI.answersNum}
              />
            </Col>
          </Row>
          <Row>
            <Col xs='12'>
              <br />
              <br />
            </Col>
          </Row>
        </div>
      )
  }
}

RatableResults.propTypes = {
  engagement:PropTypes.object.isRequired,
  engagementKPIs:PropTypes.object.isRequired
};


export default RatableResults;



// WEBPACK FOOTER //
// ./src/routes/CampaignResultsPrint/components/RatableResults.js